import attention from './attention.mp3'
import celebrate from './celebrate.mp3'
import departed from './departed.mp3'
import inspection from './inspection.mp3'
import { $t, i18n } from '~/i18n.js'
import { message } from 'antd'


const letterLookup = {
  A: 'Alpha',
  B: 'Bravo',
  C: 'Charlie',
  D: 'Delta',
  E: 'Echo',
  F: 'Foxtrot',
  G: 'Golf',
  H: 'Hotel',
  I: 'India',
  J: 'Juliet',
  K: 'Kilo',
  L: 'Lima',
  M: 'Mike',
  N: 'November',
  O: 'Oscar',
  P: 'Papa',
  Q: 'Quebec',
  R: 'Romeo',
  S: 'Sierra',
  T: 'Tango',
  U: 'Uniform',
  V: 'Victor',
  W: 'Whiskey',
  X: 'Xray',
  Y: 'Yankee',
  Z: 'Zulu'
}

const PAUZE = 100

export const text_to_speech = (callsign, msg_str) => {
  let alert_msg_str = null
  let audio_file = null;

  if (msg_str === 'BADGE') {
    return playAudio(celebrate)
  } else if (msg_str === 'UPDATE') {
    return playAudio(attention)
  } else if (msg_str === 'STARTED') {
    // play departed sound only
    return playAudio(departed)
  } else if (msg_str === "DAILY_INSPECTION") {
    audio_file = inspection
    msg_str = $t('is geinspecteerd')
    alert_msg_str = callsign + " " + $t('is geinspecteerd')
  } else if (msg_str === 'CHECKIN') {
    audio_file = attention
    msg_str = $t('is klaargezet')
    alert_msg_str = callsign + " " + $t('is klaargezet')
  } else {
    audio_file = attention
    msg_str = $t('is geland')
    alert_msg_str = callsign + " " + $t('is geland')
  }

  if (alert_msg_str) message.success(alert_msg_str, 3)

  // transcribe callsign in case the it is M12
  const transcribed_msg_str = []
  if (callsign?.length < 4) {
    // add in each number seperately
    let callsign_msg = ' '
    Array.from(callsign).forEach(c => {
      callsign_msg += (c.toUpperCase() in letterLookup ? (letterLookup[c.toUpperCase()] + ' ') : c)
    })
    transcribed_msg_str.push(callsign_msg)
  } else {
    transcribed_msg_str.push(callsign)
  }

  // then add in a pause and the msg_str
  transcribed_msg_str.push(msg_str)

  // choose good voice
  let voice = null

  // choose in NL for belgium
  const lng = i18n.language.startsWith('nl') ? 'nl-BE' : i18n.language

  window.speechSynthesis?.getVoices()?.some(v => {
    if (v.lang.includes(lng) && v.localService) {
      voice = v
      return v
    }
    return false
  })

  const speak = (index) => {
    if (index >= transcribed_msg_str.length) return null
    if (!window.speechSynthesis) return null

    const talk = new SpeechSynthesisUtterance(transcribed_msg_str[index])
    talk.lang = lng

    // setup voices
    if (voice) talk.voice = voice
    talk.rate = 0.8

    // and we ensure that by the end of this voice, we break and set the new one
    talk.onend = () => {
      setTimeout(() => speak(index + 1), PAUZE)
    }
    speechSynthesis.speak(talk)
  }

  // then we start the attention speach, after which we
  const audio = new Audio(audio_file)
  audio.onended = () => speak(0)
  audio.play().then(() => {
  }).catch(e => {
    // if error, e.g. on Safari with audio file, only do the speach
    speak(0)
  })
}

export const playCelebrate = () => playAudio(celebrate)

export const playAudio = (audioFile) => {
  const audio = new Audio(audioFile)
  try {
    audio.play().catch(e => {
      console.log('Audio not allowed');
    });
  } catch (e) {
    console.log('Audio not allowed')
  }
}
